// extracted by mini-css-extract-plugin
export var content = "Intro-module--content--2f68a";
export var contentLayout = "Intro-module--contentLayout--d139b";
export var fadeInAnimation = "Intro-module--fadeInAnimation--12d8e";
export var intro = "Intro-module--intro--3142e";
export var introWrapper = "Intro-module--introWrapper--67ea8";
export var mobileHidden = "Intro-module--mobileHidden--3b500";
export var news = "Intro-module--news--18dc5";
export var picture = "Intro-module--picture--57990";
export var pictureImage = "Intro-module--pictureImage--b1734";